<template>
  <div class="messages-box">
    <div class="action-box clearfix">
      <div
        v-if="conversationExists"
        class="contact-name">
        {{ contactName }}
      </div>
      <div
        v-if="folderp === 'open'"
        v-click-outside="hideMembers"
        class="action-item c-dropdown assignment-select float-left">
        <span
          class="action-button reassign"
          @click="toggleMemberList">
          <p class="nav d-inline-block">
            {{ assignedMember ? assignedMember.name : 'Unassigned' }}
          </p>
          <icon
            name="angle-down"
            height="12px"/>
        </span>
        <div
          v-if="showMemberList === true"
          class="c-dropdown-list">
          <div
            class="c-dropdown-close"
            @click="hideMembers">
            <icon name="times"/>
          </div>
          <div>
            <b-input-group class="search-member">
              <b-input-group-text slot="prepend">
                <icon name="search"/>
              </b-input-group-text>
              <b-input
                v-model="memberQuery"
                placeholder="Search..."/>
            </b-input-group>
          </div>
          <div class="c-dropdown-items scroll-area">
            <div
              v-if="!memberQuery"
              :class="{selected: !assignedMember }"
              class="c-dropdown-item"
              @click="assignTo()">
              <div class="user-data">
                <div class="user-info">
                  <h6 style=" margin-left: 40px">Unassigned</h6>
                </div>
              </div>
            </div>
            <template v-for="team in teams">
              <div
                v-if="team.users.length"
                :key="team.id"
                class="team">
                <div class="team-title">{{ team.name }}</div>
                <div
                  v-for="member in team.users"
                  :key="member.id"
                  :class="{selected: (assignedMember && (assignedMember.id === member.id)) }"
                  class="c-dropdown-item"
                  @click="assignTo(member.id)">
                  <div class="user-data">
                    <span
                      :style="member.avatar ? `background-image: url(${member.avatar})` : ''"
                      class="user-avatar">
                      {{ member.avatar ? '' : member.name | initials }}
                      <span
                        v-if="member.online && member.available"
                        class="indicator green"/>
                    </span>
                    <div class="user-info">
                      <h6>
                        {{ member.name }}
                      </h6>
                      <span class="email">{{ member.email }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div
        v-else
        class="action-item float-left">
        <span class="action-button reassign disabled">
          <p class="nav d-inline-block">
            {{ assignedMember ? `${assignedMember.first_name} ${assignedMember.last_name}` : 'Unassigned' }}
          </p>
        </span>
      </div>
      <div
        v-if="folderChangingAbility"
        v-click-outside="hideMessageActions"
        class="button-box">
        <span
          class="action-open"
          @click="toggleMessageActions">
          <icon name="ellipsis-v"/>
        </span>
        <div
          :class="{ opened: messageActionButtonsOpened }"
          class="action-list">
          <template v-if="folderp === 'open'">
            <span
              id="bot-status-button"
              class="action-button bot-status"
              @click="toggleBotActivation">
              <img
                v-if="conversationp.bot_active"
                src="~@/assets/img/bot-active.svg">
              <img
                v-else
                src="~@/assets/img/bot-inactive.svg">
              <b-tooltip
                target="bot-status-button"
                placement="bottom"
                offset="5, 0"
                no-fade>
                <div
                  id="bot-status-tooltip"
                  :class="conversationp.bot_active ? 'active' : 'inactive'">
                  <template v-if="conversationp.bot_active">
                    <h6><icon name="circle"/> Bot Turned On</h6>
                    <p>Turn keyword recognition off.</p>
                  </template>
                  <template v-else>
                    <h6><icon name="circle"/> Bot Turned Off</h6>
                    <p>Turn keyword recognition on.</p>
                  </template>
                </div>
              </b-tooltip>
            </span>
            <span
              id="read-message-button"
              class="action-button conversation-seen"
              @click="toggleConversationSeen">
              <img
                v-if="conversationIsUnread"
                src="~@/assets/img/message-unread.svg">
              <img
                v-else
                src="~@/assets/img/message-read.svg">
              <b-tooltip
                target="read-message-button"
                placement="bottom"
                offset="5, 0"
                no-fade>
                <div
                  id="read-message-tooltip"
                  :class="conversationIsUnread ? 'inactive' : 'active'">
                  <template v-if="conversationIsUnread">
                    <h6>Unread</h6>
                    <p>Mark conversation as read.</p>
                  </template>
                  <template v-else>
                    <h6>Read</h6>
                    <p>Mark conversation as unread.</p>
                  </template>
                </div>
              </b-tooltip>
            </span>
            <span class="float-right">
              <span
                class="btn btn-main btn-round danger"
                @click="moveToFolder('spam')">
                <icon name="trash-alt"/> Spam
              </span>
              <span
                class="btn btn-main btn-round success"
                @click="moveToFolder('done')">
                <icon name="check"/> Done
              </span>
            </span>
          </template>
          <div v-else-if="['done', 'spam'].includes(folderp)">
            <span class="float-right">
              <span
                class="btn btn-main btn-round open"
                @click="moveToFolder('open')">
                <img src="~@/assets/img/chat-open.svg"> Move to Open
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="$refs.fileUpload && $refs.fileUpload.dropActive"
      class="drop-active">
      <h4>Drop files here!</h4>
    </div>
    <MessageList
      ref="messageList"
      :conversationp="conversationp"
      :message-list-height="messageListHeight"
      @lastInboundDate="set24HourButtonVisibility"
      @initMessagesLoaded="initMessagesLoaded = true"/>
    <div
      id="input-message-box"
      class="input-message-box"
      :class="{invisible: !initMessagesLoaded}">
      <div
        v-show="!canSendMessage"
        class="notification-send-container">
        <InfoBox
          info-name="template_message_info"
          type="success"
          size="mini"
          class="template-message-info">
          24 hours have passed since the last interaction with the contact.
          Send a template message to follow up. Learn more
          <a
            href="https://developers.facebook.com/docs/whatsapp/message-templates/"
            target="_blank">here</a>.
        </InfoBox>
        <div
          class="send-notification"
          @click="openSendNotificationModal">
          <p>Send Notification</p>
        </div>
      </div>
      <div
        v-show="canSendMessage"
        class="input-message-content">
        <MessageTextArea
          ref="messageArea"
          :live-track="true"
          :editable="false"
          position="top"
          class="message-area"
          @messageChanged="commitMessage"
          @messageTyping="checkForQuickReply"
          @clipboardEvent="pasteHandler"/>
        <div class="message-actions float-right">
          <div class="message-buttons">
            <div
              v-click-outside="hideQuickReplyList"
              class="message-action">
              <span
                @click="toggleQuickReplyList">
                <img
                  src="~@/assets/img/quick-reply.svg"
                  class="img-responsive d-inline-block"
                  height="20px">
              </span>
              <div
                :class="{opened: quickRepliesOpened}"
                class="quick-reply-container">
                <QuickReplies
                  :keyword="quickReplyKeyword"
                  :track-keys="quickRepliesOpened"
                  :contact="conversationp.contact"
                  @replySelected="inputReplyToMessageArea"/>
              </div>
            </div>
            <div class="message-action">
              <dictaphone
                @stop="handleRecording"
                @error="handleRecordError">
                <template
                  slot-scope="{ isRecording, recordingTime, startRecording, stopRecording, deleteRecording }">
                  <span
                    v-if="!isRecording"
                    @click="startRecording">
                    <img
                      src="~@/assets/img/microphone.svg"
                      class="img-responsive d-inline-block"
                      height="20px">
                  </span>
                  <div
                    v-else
                    class="recording-process">
                    <div class="record-panel">
                      <span
                        class="record-button delete-record"
                        @click="deleteRecording">
                        <icon name="times"/>
                      </span>
                      <span class="time">
                        <span class="ticker"/>
                        <span class="float-right">{{ recordingTime }}</span>
                      </span>
                      <span
                        class="record-button save-record"
                        @click="stopRecording">
                        <icon name="check"/>
                      </span>
                    </div>
                  </div>
                </template>
              </dictaphone>
            </div>
            <div class="message-action">
              <file-upload
                v-if="!preventFileDrop"
                ref="fileUpload"
                :multiple="true"
                :drop="true"
                :size="16 * 1024 * 1024"
                @input-file="imageSelected">
                <img
                  src="~@/assets/img/messenger-picture.svg"
                  class="img-responsive d-inline-block"
                  height="20px">
              </file-upload>
            </div>
            <!--<div
              class="message-action highlighted"
              @click="openPaymentModal">
              <img
                src="~@/assets/img/dollar-icon.svg"
                class="img-responsive d-inline-block"
                height="18px">
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!--<PaymentModal
      ref="paymentModal"
      :contactp="conversationp.contact"/>-->
    <!-- <NotificationSendModal
      v-if="conversationp.contact"
      ref="notificationSendModal"
      :fixed="true"
      :force-fill-subscriber="true"
      :contactp="conversationp.contact"
      @sent="setTemplateMessage"/> -->
    <PasteImageModal
      ref="pasteImageModalRef"
      @sendImage="inputFile"/>
    <!-- <InfoModal
      ref="permissionInfoModal"
      message="You don't have permission to do this action."/> -->
    <AudioRecordErrorModal
      ref="audioRecordErrorModal"/>
    <div
      v-if="!conversationsLoaded || !conversationExists"
      class="disable-actions"/>
  </div>
</template>

<script>
import ClickOutside from 'v-click-outside';
import { mapActions, mapGetters } from 'vuex';
import FileUpload from 'vue-upload-component';
import resizeObserver from 'element-resize-event';
import randomString from '@/helpers/randomString';
import retrieveImageFromClipboardAsBlob from '@/helpers/imageUtils';
import MessageList from './partials/MessageList';
import QuickReplies from './partials/QuickReplies';
// import NotificationSendModal from '../notifications/modals/NotificationSendModal';
import MessageTextArea from '../../common/MessageTextArea';
import Dictaphone from '../../common/recorder/Dictaphone';
import InfoBox from '../../common/InfoBox';
import InfoModal from '../../common/modals/InfoModal';
import AudioRecordErrorModal from './modals/AudioRecordErrorModal';
import PasteImageModal from '../notifications/modals/PasteImageModal';

export default {
  name: 'Messages',
  components: {
    MessageList,
    QuickReplies,
    MessageTextArea,
    FileUpload,
    Dictaphone,
    InfoBox,
    InfoModal,
    // NotificationSendModal,
    AudioRecordErrorModal,
    PasteImageModal,
  },
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  props: {
    conversationp: {
      type: Object,
      default: () => {},
    },
    folderp: {
      type: String,
      default: 'open',
    },
    assignmentp: {
      type: String,
      default: 'all',
    },
  },
  data() {
    return {
      message: '',
      memberQuery: '',
      teams: [],
      now: this.$moment(),
      userId: localStorage.getItem('userId'),
      showMemberList: false,
      assignedMember: null,
      messageListHeight: null,
      quickReplyKeyword: null,
      folderChangingAbility: true,
      messageActionButtonsOpened: false,
      quickRepliesOpened: false,
      hasSendNotificationPermission: this.$hasPermission('send_notifications', this.$route.params.merchant_id),
      messageBox: null,
      preventFileDrop: false,
      dropareaActiveMarker: false,
      canSendMessage: false,
      initMessagesLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
      members: 'merchant/members',
      teamList: 'team/teamList',
      reassignedConversation: 'chat/reassignedConversation',
      newConversationActivity: 'pusher/newConversationActivity',
      conversationsLoad: 'chat/conversationsLoad',
      messageSent: 'chat/messageSent',
      apiError: 'chat/apiError',
    }),
    conversationsLoaded() {
      return this.conversationsLoad.loaded || (this.conversationsLoad.page !== 1);
    },
    conversationIsUnread() {
      return !this.conversationp.seen || (!this.conversationp.assignment_seen && (this.conversationp.user_id === this.userId));
    },
    contactName() {
      if (this.conversationp.contact) {
        return this.conversationp.contact.name ? this.conversationp.contact.name : this.conversationp.contact.phone;
      }

      return '';
    },
    conversationExists() {
      return !this.$lodash.isEmpty(this.conversationp);
    },
  },
  watch: {
    conversationp(conversation) {
      this.canSendMessage = false;
      this.initMessagesLoaded = false;
      if (!this.$lodash.isEmpty(conversation)) {
        if (!this.$lodash.isEmpty(this.members) && conversation.user_id) {
          this.assignedMember = this.$lodash.find(this.members, { id: conversation.user_id });
        } else {
          this.assignedMember = null;
        }

        this.$refs.messageList.resetPagination();
        this.$nextTick(() => {
          this.$refs.messageList.loadMessages();
        });
      } else {
        this.assignedMember = null;
      }
    },
    // eslint-disable-next-line func-names
    'conversationp.changed_activity': function (activity) {
      this.folderChangingAbility = activity ? activity.type !== 'folder_changed' : true;
    },
    teamList(teamList) {
      this.teams = teamList;
    },
    memberQuery(queryString) {
      this.teams = this.teamList.map((team) => {
        const query = queryString.toLowerCase();
        const teamCopy = Object.assign({}, team);
        teamCopy.users = teamCopy.users.filter(user => (user.name.toLowerCase().indexOf(query) !== -1) ||
            (user.email.toLowerCase().indexOf(query) !== -1));

        return teamCopy;
      });
    },
    members(members) {
      if (!this.$lodash.isEmpty(this.conversationp) && !this.$lodash.isEmpty(members)) {
        this.assignedMember = this.$lodash.find(members, { id: this.conversationp.user_id });
      }
    },
    reassignedConversation(payload) {
      if (this.assignmentp === 'all' && (this.conversationp.id === payload.conversation_id)) {
        this.assignedMember = this.$lodash.find(this.members, { id: payload.user_id });
      }
    },
    newConversationActivity(payload) {
      const activity = payload.activity;
      if ((activity.action === 'assignment') && (this.conversationp.id === activity.conversation_id)) {
        this.assignedMember = this.$lodash.find(this.members, { id: activity.to_user_id });
      }
    },
    messageSent(message) {
      if (message && (this.conversationp.id === message.conversation_id)) {
        this.$refs.messageList.changeTempData(message);
        this.conversationp.last_message_sid = message.sid;
      }
    },
  },
  mounted() {
    this.fetchTeams(this.$route.params.merchant_id);
    this.calculateMessageListHeight();
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      this.preventFileDrop = true;
    });
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      this.preventFileDrop = false;
    });
    // There is also an event fireing on the MessageTextArea component since emojionearea stops propagation so it had to be emited from the component directly.
    window.addEventListener('paste', this.pasteHandler, false);
  },
  beforeDestroy() {
    resizeObserver.unbind(this.messageBox);
    window.removeEventListener('paste', this.pasteHandler);
  },
  methods: {
    ...mapActions({
      sendMessage: 'chat/sendMessage',
      sendMedia: 'chat/sendMedia',
      reassignConversation: 'chat/reassignConversation',
      markConversationAsSeen: 'chat/markConversationAsSeen',
      changeFolder: 'chat/changeFolder',
      fetchTeams: 'team/fetchTeamList',
      updateBotStatus: 'chat/updateBotStatus',
    }),
    retrieveImageFromClipboardAsBlob,
    assignTo(memberId = null) {
      if (this.assignedMember && (this.assignedMember.id === memberId)) {
        return;
      }
      this.reassignConversation({
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        user_id: memberId,
        infoModal: this.$infoModal,
      });
      this.showMemberList = false;
    },
    commitMessage(message) {
      if (!message || this.quickRepliesOpened) {
        return;
      }

      const tempSid = randomString();
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        data: {
          message,
          temp_sid: tempSid,
        },
      };

      this.conversationp.bot_active = false;
      this.$refs.messageList.addOutboundMessage(tempSid, message);
      this.$refs.messageArea.clear();
      this.sendMessage(payload);
    },
    setTemplateMessage(message) {
      this.$refs.messageList.addTemplateMessage(message);

      if (this.conversationp.id !== this.userId) {
        this.assignedMember = this.$lodash.find(this.members, { id: this.userId });
      }
    },
    moveToFolder(folder) {
      this.changeFolder({
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        data: {
          folder,
        },
      });
    },
    addFileMessage(fileData) {
      this.$refs.messageList.addOutboundMedia(fileData);
    },
    hideMembers() {
      this.showMemberList = false;
    },
    toggleMemberList() {
      this.showMemberList = !this.showMemberList;

      if (this.showMemberList) {
        this.memberQuery = '';
        this.fetchTeams(this.$route.params.merchant_id);
      }
    },
    toggleQuickReplyList() {
      this.quickRepliesOpened = !this.quickRepliesOpened;

      if (this.quickRepliesOpened && this.$refs.messageArea.isEmpty()) {
        this.$refs.messageArea.setText('/');
        this.$refs.messageArea.focusEnd();
      } else if (!this.quickRepliesOpened && this.$refs.messageArea.getText() === '/') {
        this.$refs.messageArea.setText('');
      }
    },
    hideQuickReplyList() {
      this.quickRepliesOpened = false;

      if (this.$refs.messageArea.getText() === '/') {
        this.$refs.messageArea.setText('');
      }
    },
    toggleBotActivation() {
      this.conversationp.bot_active = !this.conversationp.bot_active;
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        data: {
          bot_active: this.conversationp.bot_active,
        },
      };

      this.updateBotStatus(payload);
    },
    toggleConversationSeen() {
      const seen = this.conversationIsUnread;
      this.conversationp.seen = seen;
      this.conversationp.assignment_seen = seen;
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        data: {
          seen,
          includeMe: true,
        },
      };

      this.markConversationAsSeen(payload);
    },
    inputReplyToMessageArea(replyMessage) {
      this.$refs.messageArea.setText(replyMessage);
      this.$refs.messageArea.focusEnd();
      this.quickRepliesOpened = false;
    },
    checkForQuickReply(text) {
      if (text.indexOf('/') === 0 && text.indexOf(' ') === -1) {
        this.quickRepliesOpened = true;
        this.quickReplyKeyword = text.substr(1);
      } else {
        this.quickRepliesOpened = false;
        this.quickReplyKeyword = '';
      }
    },
    detectFolderChangingAbility() {
      this.folderChangingAbility = this.conversationp.changed_activity ? this.conversationp.changed_activity.type !== 'folder_changed' : true;
    },
    inputFile(fileData) {
      const formData = new FormData();
      const tempSid = randomString();

      formData.append('file', fileData.file);
      formData.append('temp_sid', tempSid);
      if (fileData.caption) {
        formData.append('caption', fileData.caption);
      }

      this.$refs.messageList.addOutboundMedia({
        temp_sid: tempSid,
        media_type: fileData.type,
        media_name: fileData.caption,
      });

      this.sendMedia({
        merchant_id: this.$route.params.merchant_id,
        conversation_id: this.conversationp.id,
        data: formData,
      });

      this.$refs.messageArea.clear();
    },
    // openPaymentModal() {
    //   this.$refs.paymentModal.show();
    // },
    // openSendNotificationModal() {
    //   if (this.hasSendNotificationPermission) {
    //     this.$refs.notificationSendModal.show();
    //   } else {
    //     this.$refs.permissionInfoModal.show();
    //   }
    // },
    toggleMessageActions() {
      this.messageActionButtonsOpened = !this.messageActionButtonsOpened;
    },
    hideMessageActions() {
      this.messageActionButtonsOpened = false;
    },
    calculateMessageListHeight() {
      this.messageBox = document.getElementById('input-message-box');

      this.setmessageListHeight();

      resizeObserver(this.messageBox, () => {
        this.setmessageListHeight();
      });
    },
    setmessageListHeight() {
      const messageAreaHeight = this.messageBox ? this.messageBox.offsetHeight : 48;
      this.messageListHeight = `calc(100% - ${56 + messageAreaHeight}px)`;
    },
    handleRecording(fileData) {
      const blob = fileData.blob;
      blob.lastModifiedDate = new Date();
      blob.lastModified = blob.lastModifiedDate.getTime();
      blob.name = `audio-${randomString()}.wav`;

      this.inputFile({
        type: 'audio/wav',
        name: blob.name,
        file: blob,
      });
    },
    handleRecordError(error) {
      this.$refs.audioRecordErrorModal.show(error.name);
    },
    /**
     * Method checks data on the clipboard when paste event if received and shows image modal if it finds an image in there.
     *
     * @param event ClipboardEvent
     */
    pasteHandler(event) {
      const images = this.retrieveImageFromClipboardAsBlob(event);
      // modal accepts only one image from clipboard which is why we only use the first item
      if (images[0]) {
        this.$refs.pasteImageModalRef.show(images[0], this.$refs.messageArea.getText());
      }
    },
    /**
     * If images or files were dropped then just send it.
     * Otherwise(paste or select) show the preview window with caption field.
     */
    imageSelected(file) {
      if (file.type.indexOf('image') === -1 && file.type.indexOf('video') === -1) {
        this.inputFile(file);
        return;
      }
      this.$refs.pasteImageModalRef.show(file.file, this.$refs.messageArea.getText());
    },
    /**
     * Sets the notification button visibility.
     *
     * @param lastInboundDate Date of the last inbound message.
     */
    set24HourButtonVisibility(lastInboundDate) {
      this.canSendMessage = Boolean(lastInboundDate && this.$moment(lastInboundDate).diff(this.now, 'days') === 0);
    },
  },
};
</script>